import { h, Fragment } from "preact";
import useProduct from "../../helpers/useProduct/useProduct";
import useProducts from "../../helpers/useProduct/useProducts";
import ProductSetContent from "./product-set-content";

export default function ProductSet({ productId, idPrefix, initialVariantId }) {
  const [productData] = useProduct(productId);
  const [setProductsData] = useProducts(
    productData?.setProducts?.map(({ product }) => product.id) || [],
  );
  console.log(`setProductsData`, setProductsData);
  if (!productData || !setProductsData) return null;

  return (
    <ProductSetContent
      idPrefix={idPrefix}
      initialVariantId={initialVariantId}
      productData={productData}
      setProductsData={setProductsData}
    />
  );
}
